import { useState } from "react";
import { api } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Star, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function Stars({ value, count, size = "w-3.5 h-3.5", tid }) {
  if (!value) return <span className="text-[11px] text-slate-500" data-testid={tid}>New driver</span>;
  return (
    <span className="inline-flex items-center gap-1 text-xs text-amber-300" data-testid={tid}>
      <Star className={`${size} fill-amber-300`} />{Number(value).toFixed(1)}{count != null && <span className="text-slate-500">({count})</span>}
    </span>
  );
}

export default function RateDriverDialog({ job, open, onOpenChange, onRated }) {
  const [stars, setStars] = useState(5);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try { await api.post(`/gigs/jobs/${job.job_id}/rate`, { stars, comment: comment || null }); toast.success("Thanks for rating!"); onRated?.(); onOpenChange(false); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not submit rating"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0B0D12] border-slate-800 max-w-sm" data-testid="rate-driver-dialog">
        <DialogHeader><DialogTitle className="font-display">Rate {job?.driver_name || "your driver"}</DialogTitle></DialogHeader>
        <div className="flex gap-1 justify-center py-2">
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} onClick={() => setStars(n)} data-testid={`rate-star-${n}`} className="p-1 transition-transform hover:scale-110">
              <Star className={`w-8 h-8 ${n <= stars ? "fill-amber-300 text-amber-300" : "text-slate-700"}`} />
            </button>
          ))}
        </div>
        <Textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="On time? Careful with the items? (optional)" data-testid="rate-comment" className="bg-slate-900 border-slate-800" />
        <Button onClick={submit} disabled={busy} data-testid="rate-submit-btn" className="bg-amber-400 text-slate-950 hover:bg-amber-300 font-semibold">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : `Submit ${stars}★`}</Button>
      </DialogContent>
    </Dialog>
  );
}
